import {
    CHANGE_BET_SLIP_MODAL_SELECTED_SCREEN,
    OPEN_CLOSE_BET_SLIP_MODAL,
    SET_BET_SLIP_VIEW
} from '../../../constants/actionTypes';
import {SET_BET_SLIP_CONTAINER_HEIGHT, TOGGLE_FILTER_WINS_SETTLED_BETS} from "../constants/actionTypes";


export function openCloseBetSlipModal() {
    return {type: OPEN_CLOSE_BET_SLIP_MODAL};
}

export function changeBetSlipModalSelectedScreen(option) {
    return {type: CHANGE_BET_SLIP_MODAL_SELECTED_SCREEN, option};
}

export function toggleFilterWinsSettledBets() {
    return {type: TOGGLE_FILTER_WINS_SETTLED_BETS};
}
export function setBetSlipModalContainerHeight(height) {
    return {type: SET_BET_SLIP_CONTAINER_HEIGHT,height};
}


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/actions/betSlipActions.js